import { useSelector } from 'react-redux';
import { TRIGGER_METADATA } from 'modules/workflows/constants';
import {
  getStartNodeTriggerEventName,
  getStartNodeTriggerNodeClass,
} from 'modules/workflows/ducks';
import { StartFilled } from 'ui/icons';
import { colors } from 'ui/theme';
import { TinyTile, IconContainer } from './styles';

export const EVENT_NAME_TEST_ID = 'event-name';
export const TINY_TILE_TEST_ID = 'tiny-tile';
export const START_FILLED_ICON_TEST_ID = 'start-filled-icon';
export const ICON_CONTAINER_TEST_ID = 'icon-container';
export const START_TEXT_TEST_ID = 'start-text';
export const TRIGGER_LABEL_TEST_ID = 'trigger-label';

export const Description = ({ isAllEventsSelected }: { isAllEventsSelected: boolean }) => {
  const startNodeNodeClass = useSelector(getStartNodeTriggerNodeClass);
  const startNodeEventName = useSelector(getStartNodeTriggerEventName);

  return (
    <TinyTile data-test={TINY_TILE_TEST_ID} isDisabled={isAllEventsSelected}>
      <IconContainer data-test={ICON_CONTAINER_TEST_ID} isDisabled={isAllEventsSelected}>
        <StartFilled data-test={START_FILLED_ICON_TEST_ID} width={13.5} color={colors.white} />
      </IconContainer>
      <div data-test={TRIGGER_LABEL_TEST_ID}>
        <span data-test={START_TEXT_TEST_ID}>Start</span>
        <span data-test={EVENT_NAME_TEST_ID}>
          {`${TRIGGER_METADATA[startNodeNodeClass]?.label}${startNodeEventName ? `: “${startNodeEventName}”` : ''}`}
        </span>
      </div>
    </TinyTile>
  );
};
